import React from "react";
import Loader from "./utils/Loader";
import "./asssets/css/App.css";

const MainApp = React.lazy(() => import("./Screens/Home"));

function App() {
  return (
    <React.Suspense
      fallback={
        <div className="loader">
          <Loader />
        </div>
      }
    >
      <MainApp />
    </React.Suspense>
  );
}

export default App;
